// Environment configuration helper
export const env = {
  // API Configuration
  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:5000/api/v1',
  
  // Stripe Configuration
  STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '',
  
  // Payment Configuration
  PAYMENT_CURRENCY: import.meta.env.VITE_PAYMENT_CURRENCY || 'EUR',
  PAYMENT_COUNTRY: import.meta.env.VITE_PAYMENT_COUNTRY || 'ES',

  // Bank Transfer (for displaying instructions client-side)
  BANK_IBAN: import.meta.env.VITE_BANK_IBAN || '',
  BANK_HOLDER: import.meta.env.VITE_BANK_HOLDER || 'Jarad Pet Food S.L.',
  
  // Environment
  NODE_ENV: import.meta.env.MODE || 'development',
  DEV: import.meta.env.DEV || false,
  PROD: import.meta.env.PROD || false,
} as const;

// Validation helper
export const validateEnv = () => {
  const required = ['STRIPE_PUBLISHABLE_KEY'];
  const missing = required.filter(key => !env[key as keyof typeof env]);
  
  if (missing.length > 0) {
    console.warn('Missing required environment variables:', missing);
    return false;
  }
  
  return true;
};

export default env;